module.exports = __webpack_public_path__ + "img/logo-1.75803b78.png";